(function(){
  function initSection(sectionEl){
    if (!window.Swiper) {
      // Retry after Swiper loads
      setTimeout(function(){ initSection(sectionEl); }, 100);
      return;
    }
    var swiperEl = sectionEl.querySelector('.sensations-main__swiper');
    if (!swiperEl || sectionEl._sensationsSwiper) return;

    var paginationEl = sectionEl.querySelector('.sensations-main__pagination');

    var swiper = new Swiper(swiperEl, {
      direction: 'vertical',
      slidesPerView: 'auto',
      speed: 700,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1
      },
      keyboard: {
        enabled: true
      },
      pagination: {
        el: paginationEl,
        clickable: true
      },
      watchOverflow: true
    });

    sectionEl._sensationsSwiper = swiper;

    // Avoid browser scroll chaining while interacting with the slider
    if (swiperEl && swiperEl.style) {
      try { swiperEl.style.overscrollBehavior = 'contain'; } catch(_) {}
    }

    // While user scrolls inside the slider, block page scroll; allow page scroll only at the first/last slide
    var wheelHandler = function(e){
      try {
        if (!e || typeof e.deltaY !== 'number') return;
        var dy = e.deltaY;
        var atStart = swiper.isBeginning && swiper.activeIndex === 0;
        var atEnd = swiper.isEnd;
        var single = (swiper.slides && swiper.slides.length <= 1);
        // If only one slide, let the page scroll normally
        if (single) return;
        // Prevent page scroll while navigating between slides or during animation
        if (swiper.animating || (dy < 0 && !atStart) || (dy > 0 && !atEnd)) {
          e.preventDefault();
          return;
        }
        // At the edges, do not prevent default — allow page scroll to take over
      } catch (err) {
        // noop
      }
    };
    sectionEl._sensationsWheelHandler = wheelHandler;
    swiperEl.addEventListener('wheel', wheelHandler, { passive: false });
  }

  function initAll(){
    document.querySelectorAll('.sensations-main').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify section lifecycle
  document.addEventListener('shopify:section:load', function(event){
    var container = event.target;
    var sectionEl = container && container.querySelector && container.querySelector('.sensations-main');
    if (sectionEl) initSection(sectionEl);
  });

  document.addEventListener('shopify:section:unload', function(event){
    var container = event.target;
    var sectionEl = container && container.querySelector && container.querySelector('.sensations-main');
    if (sectionEl) {
      if (sectionEl._sensationsWheelHandler) {
        var swiperEl = sectionEl.querySelector('.sensations-main__swiper');
        if (swiperEl) swiperEl.removeEventListener('wheel', sectionEl._sensationsWheelHandler);
        delete sectionEl._sensationsWheelHandler;
      }
      if (sectionEl._sensationsSwiper) {
        sectionEl._sensationsSwiper.destroy(true, true);
        delete sectionEl._sensationsSwiper;
      }
    }
  });
})();
